<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10">
        <br v-if="step == 1" />
        <br v-if="step == 1" />
        <br v-if="step == 1" />
        <v-card class="elevation-3 mt-10">
          <v-window v-model="step">
            <!--Inicio de sesión-->
            <v-window-item :value="1">
              <v-row>
                <!--Sector Digitar Inicio de Sesión-->
                <v-col cols="12" md="6">
                  <v-card-text class="mt-12">
                    <h2 class="text-center">Inicio de sesión</h2>
                    <v-img
                      class="mx-auto mt-3"
                      :width="200"
                      aspect-ratio="16/9"
                      cover
                      src="/static/iconos/logo1.png"
                    ></v-img>
                    <v-row align="center" justify="center">
                      <v-col cols="12" sm="8">
                        <v-text-field
                          v-model="Email"
                          label="Correo Electrónico:"
                          outlined
                          dense
                          color="blue"
                          autocomplete="false"
                          class="mt-5"
                        />
                        <v-text-field
                          v-model="Password"
                          label="Digite su contraseña"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          outlined
                          dense
                          color="blue"
                          autocomplete="false"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                        />
                        <v-btn color="red-darken-4" dark block tile @click="AccesoLogin"
                          >Iniciar Sesión</v-btn
                        >
                        <v-row>
                          <v-spacer />
                          <v-col cols="12" sm="12">
                            <br />
                            <v-btn
                              @click="dialog = !dialog"
                              color="red-darken-4"
                              block
                              dark
                              tile
                            >
                              ¿Olvidó su contraseña?
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-spacer />
                          <v-col class="text-center" cols="12" sm="12">
                            <span> Versión: 5.4.0 </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
                <!--Sector Acceder a Registro de usuario-->
                <v-col cols="12" md="6" class="bg-red-darken-4 rounded-bl-xl">
                  <div style="text-align: center; padding: 100px 0">
                    <v-card-text class="white--text">
                      <v-img
                        class="mx-auto mt-3"
                        :width="100"
                        aspect-ratio="16/9"
                        cover
                        src="/static/iconos/logo2.png"
                      ></v-img>
                      <h3 class="text-center">Bienvenido a TCI Software</h3>
                      <br />
                      <span class="text-center">
                        Un aplicativo que busca mejorar la experiencia tecnológica del
                        cliente,<br />
                        ofreciendo servicios y productos para el beneficio de sus
                        proyectos.
                      </span>
                    </v-card-text>
                    <div class="text-center">
                      <v-btn color="#686867" tile outlined dark @click="step++"
                        >Crear cuenta</v-btn
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>
            <!--Registro-->
            <v-window-item :value="2">
              <v-row>
                <!--Sector acceder a Inicio de sesión-->
                <v-col cols="12" md="6" class="bg-red-darken-4 rounded-br-xl">
                  <div style="text-align: center; padding: 180px 0">
                    <v-card-text class="white--text">
                      <v-img
                        class="mx-auto mt-3"
                        :width="100"
                        aspect-ratio="16/9"
                        cover
                        src="/static/iconos/logo2.png"
                      ></v-img>
                      <h3 class="text-center">Bienvenido a TCI Software</h3>
                      <br />
                      <span class="text-center">
                        Un aplicativo que busca mejorar la experiencia tecnológica del
                        cliente,<br />
                        ofreciendo servicios y productos para el beneficio de sus
                        proyectos.
                      </span>
                      <br /><br /><br />
                      <h3 class="text-center">¿Ya creo una cuenta?</h3>
                      <span class="text-center">
                        Selecciona el botón de Iniciar sesión para acceder a su cuenta<br />
                      </span>
                    </v-card-text>
                    <div class="text-center">
                      <v-btn color="#686867" tile outlined dark @click="step--"
                        >Iniciar Sesión</v-btn
                      >
                    </div>
                  </div>
                </v-col>
                <!--Sector Formulario de registro-->
                <v-col cols="12" md="6">
                  <v-card-text class="mt-12">
                    <h2 class="text-center">Registrese</h2>
                    <v-img
                      class="mx-auto mt-3"
                      :width="200"
                      aspect-ratio="16/9"
                      cover
                      src="/static/iconos/logo1.png"
                    ></v-img>
                    <v-row align="center" justify="center">
                      <v-col cols="12" sm="8">
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="Digite su primer nombre"
                              outlined
                              dense
                              color="blue"
                              autocomplete="false"
                              class="mt-4"
                            />
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="Digite su primer apellido"
                              outlined
                              dense
                              color="blue"
                              autocomplete="false"
                              class="mt-4"
                            />
                          </v-col>
                        </v-row>
                        <v-text-field
                          label="Digite su usuario"
                          outlined
                          dense
                          color="blue"
                          autocomplete="false"
                          class="mt-5"
                        />
                        <v-text-field
                          label="Digite su correo"
                          outlined
                          dense
                          color="blue"
                          autocomplete="false"
                        />
                        <v-text-field
                          label="Digite su contraseña"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          outlined
                          dense
                          color="blue"
                          autocomplete="false"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                        />
                        <v-text-field
                          label="Digite su contraseña nuevamente"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          outlined
                          dense
                          color="blue"
                          autocomplete="false"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                        />
                        <v-row>
                          <v-col cols="12" sm="7">
                            <v-checkbox label="Acepta T&C" class="mt-n1" color="blue">
                            </v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="5">
                            <span class="caption blue--text ml-n4"
                              >Terminos & Condiciones</span
                            >
                          </v-col>
                        </v-row>
                        <v-btn color="red-darken-4" dark block tile>Registrarse</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <!-- Linea de progreso -->
  <v-dialog v-model="progreso" persistent width="auto">
    <v-card color="red-darken-4">
      <v-card-text>
        Espera un momento...
        <v-toolbar align="center" color="red-darken-4">
          <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
        </v-toolbar>
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Dialogo la olvido de contraseña -->
  <div class="text-center pa-4">
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card
        prepend-icon="mdi-account-circle"
        text="Por favor digite su correo electrónico para validar su cuenta"
        title="¿Olvidó su contraseña?"
      >
        <v-divider class="mt-3"></v-divider>

        <v-card-text class="px-4">
          <v-text-field
            v-model="EmailOlvido"
            label="Correo Electrónico:"
            outlined
            dense
            color="blue"
            autocomplete="false"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="
              dialog = false;
              EmailOlvido = '';
            "
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="ChaneEmailLogin()" color="success"> Validar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <!-- Dialogo de OTP -->
  <div class="text-center pa-4">
    <v-dialog v-model="otpdialog" max-width="600" persistent>
      <v-card
        prepend-icon="mdi-account-circle"
        text="Al correo electrónico se ha enviado un código de verificación, por favor digítelo en el siguiente campo. Este código es válido por 10 minutos e intransferible."
        title="Código de verificación"
      >
        <v-divider class="mt-3"></v-divider>

        <v-card-text class="px-4">
          <v-text-field
            v-model="verifationcode"
            label="Código Verificación:"
            v-on:keypress="isNumber()"
            hint="Digite el código de verificación de 6 digitos"
            dense
            clearable
            prefix="TCI - "
            maxlength="6"
            counter="6"
            autocomplete="false"
          >
          </v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="
              dialog = false;
              otpdialog = false;
              EmailOlvido = '';
            "
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="ValidateCodeVerification()" color="success"> Comprobar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <!-- Dialogo su nuevo password -->
  <div class="text-center pa-4">
    <v-dialog v-model="dialogchange" max-width="600" persistent>
      <v-card
        prepend-icon="mdi-account-circle"
        text="Recuerde que su contraseña de ser minimo de 8 caracteres, incluir mayúsculas y minúsculas, números y simbolos especiales."
        title="Cambio de contraseña"
      >
        <v-divider class="mt-3"></v-divider>

        <v-card-text class="px-4">
          <v-text-field
            v-model="passwordNew"
            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible ? 'text' : 'password'"
            density="compact"
            placeholder="Digite su nueva contraseña"
            prepend-inner-icon="mdi-lock-outline"
            variant="outlined"
            @click:append-inner="visible = !visible"
            autocomplete="false"
          ></v-text-field>

          <v-text-field
            v-model="passwordNew2"
            :append-inner-icon="visible2 ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible2 ? 'text' : 'password'"
            density="compact"
            placeholder="Digite nuevamente su nueva contraseña"
            prepend-inner-icon="mdi-lock-outline"
            variant="outlined"
            @click:append-inner="visible2 = !visible2"
            autocomplete="false"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="
              dialog = false;
              dialogchange = false;
              otpdialog = false;
              EmailOlvido = '';
            "
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="ValidateNewPassword()" color="success">
            Actualizar Contraseña
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import CryptoJS from "crypto-js";
import format from "date-fns/format";
const key = "eXSQ6pSMaax9fA8dJLURCWn79jMPskCj";
const iv = "0000000000000000";
export default {
  data: () => ({
    step: 1,
    progreso: false,
    dialog: false,
    dialogchange: false,
    show1: false,
    Email: "",
    EmailOlvido: "",
    otpdialog: false,
    verifationcode: "",
    Password: "",
    PasswordSHA: "",
    visible: false,
    visible2: false,
    tokenuser: "",
    ArrayUser: [],
    passwordNew: "",
    passwordNew2: "",
  }),
  methods: {
    // Verificacion de numeros
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // Encriptación en AES
    aesEncrypt(txt) {
      const cipher = CryptoJS.AES.encrypt(txt, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
      });
      return cipher.toString();
    },
    //Encriptación en SHA256
    async sha256(message) {
      const msgBuffer = new TextEncoder().encode(message); // Codifica la cadena a utf-8
      const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer); // Genera el hash SHA-256 del buffer de mensajes
      const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convierte el hash buffer en un array de bytes
      const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join(""); // Convierte el array de bytes en una cadena hexadecimal return hashHex;
      this.PasswordSHA = hashHex;
    },
    // Consulta si el usuario exista en el sistema
    async AccesoLogin() {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (pattern.test(this.Email)) {
        if (this.Password != "" && this.Password != undefined) {
          this.progreso = true;
          this.tokenuser = "";
          var passwordorigin = this.Email + "#" + this.Password;
          // Convertir constaseña en Password
          await this.sha256(this.Password);
          passwordorigin = this.aesEncrypt(passwordorigin);
          // Token cifrado
          const fecha = format(new Date(), "yyyyMMddHHmmss");
          var token =
            this.Email + "#" + this.Email + "#" + fecha + "#" + this.PasswordSHA;
          this.tokenuser = this.aesEncrypt(token);
          var datainfo = {
            PasswordAES: passwordorigin,
            PasswordSHA: this.PasswordSHA,
            Token: this.tokenuser,
          };
          this.axios
            .post(this.$store.state.apiService + "/Autenticacion/login/", datainfo)
            .then((response) => {
              this.$store.commit("userInfo", response.data);
              localStorage.removeItem("token");
              localStorage.setItem("token", response.data.TokenSesion);
              localStorage.removeItem("infoperfil");
              localStorage.removeItem("registromenu");
              localStorage.removeItem("paginainfo");
              this.axios.defaults.baseURL = "";
              this.axios.defaults.headers.common["Authorization"] = "";
              this.axios.defaults.timeout = 0;
              this.$router.push("/perfiles");
            })
            .catch((error) => {
              const registro = error.response.data;
              const mensajeerror =
                registro.Mensaje || registro.ExceptionMessage || registro;
              switch (error.response.status) {
                case 404:
                  this.$swal({
                    icon: "warning",
                    title: "Consulta inexistente.",
                    html: " [404] No existen datos para esta consulta.",
                  });
                  break;
                default:
                  this.$swal({
                    icon: "error",
                    title: "Error al consultar",
                    html:
                      " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                      mensajeerror +
                      "</code></small>",
                  });
                  break;
              }
            })
            .finally(() => {
              this.progreso = false;
            });
        } else {
          this.$swal({
            icon: "warning",
            title: "Falta información.",
            html: " Falta registrar el campo de contraseña, por favor revisar.",
          });
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Correo Inválido.",
          html: " El campo de correo no cumple con los estándares establecidos.",
        });
      }
    },

    // Consulta Cambio de contraseña
    async ChaneEmailLogin() {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (pattern.test(this.EmailOlvido)) {
        if (this.EmailOlvido != "" && this.EmailOlvido != undefined) {
          this.progreso = true;
          // Convertir constaseña en Password
          var emailorigin = this.aesEncrypt(this.EmailOlvido + "#" + this.EmailOlvido);

          this.axios
            .get(
              this.$store.state.apiService + "/OTP/GenerateOTPUser?email=" + emailorigin
            )
            .then((response) => {
              this.verifationcode = null;
              this.otpdialog = true;
            })
            .catch((error) => {
              const registro = error.response.data;
              console.log(registro);
              const mensajeerror =
                registro.Mensaje || registro.ExceptionMessage || registro;
              switch (error.response.status) {
                case 404:
                  this.$swal({
                    icon: "warning",
                    title: "Consulta inexistente.",
                    html: " [404] No existen información para este usuario.",
                  });
                  break;
                case 401:
                  this.$swal({
                    icon: "warning",
                    title: "Usuario inexistente.",
                    html: " [401] Este usuario no se encuentra registrado en el sistema.",
                  });
                  break;
                default:
                  this.$swal({
                    icon: "error",
                    title: "Error al consultar",
                    html:
                      " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                      mensajeerror +
                      "</code></small>",
                  });
                  break;
              }
            })
            .finally(() => {
              this.progreso = false;
            });
        } else {
          this.$swal({
            icon: "warning",
            title: "Falta información.",
            html: " Falta registrar el campo de contraseña, por favor revisar.",
          });
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Correo Inválido.",
          html: " El campo de correo no cumple con los estándares establecidos.",
        });
      }
    },

    // Comprobar Código de verificación
    async ValidateCodeVerification() {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (pattern.test(this.EmailOlvido)) {
        if (
          this.EmailOlvido != "" &&
          this.EmailOlvido != undefined &&
          this.verifationcode != "" &&
          this.verifationcode != undefined
        ) {
          this.progreso = true;
          // Convertir constaseña en Password
          var emailorigin = this.aesEncrypt(this.EmailOlvido + "#" + this.EmailOlvido);

          // Convertir constaseña en Password
          await this.sha256(this.verifationcode);

          var datainfo = {
            Email: emailorigin,
            OTP: this.PasswordSHA,
          };

          this.axios
            .post(this.$store.state.apiService + "/OTP/validateOTPUser", datainfo)
            .then((response) => {
              this.dialogchange = true;
            })
            .catch((error) => {
              const registro = error.response.data;
              const mensajeerror =
                registro.Mensaje || registro.ExceptionMessage || registro;
              switch (error.response.status) {
                case 404:
                  this.$swal({
                    icon: "warning",
                    title: "Consulta inexistente.",
                    html: " [404] No existen datos para esta consulta.",
                  });
                  break;
                default:
                  this.$swal({
                    icon: "error",
                    title: "Error al consultar",
                    html:
                      " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                      mensajeerror +
                      "</code></small>",
                  });
                  break;
              }
            })
            .finally(() => {
              this.progreso = false;
            });
        } else {
          this.$swal({
            icon: "warning",
            title: "Falta información.",
            html: " Falta registrar el campo de contraseña, por favor revisar.",
          });
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Correo Inválido.",
          html: " El campo de correo no cumple con los estándares establecidos.",
        });
      }
    },

    ValidateNewPassword() {
      if (this.passwordNew != this.passwordNew2) {
        this.$swal({
          icon: "warning",
          title: "Contraseñas no coinciden.",
          html: " Las contraseñas no coinciden, por favor revisar.",
        });
      } else if (this.passwordNew.length < 8 || this.passwordNew2.length < 8) {
        this.$swal({
          icon: "warning",
          title: "Contraseña débil.",
          html: " La contraseña debe tener al menos 8 caracteres.",
        });
      } else if (
        !this.passwordNew.match(/[a-z]/) ||
        !this.passwordNew.match(/[A-Z]/) ||
        !this.passwordNew.match(/[0-9]/) ||
        !this.passwordNew.match(/[^a-zA-Z\d]/)
      ) {
        this.$swal({
          icon: "warning",
          title: "Contraseña débil.",
          html:
            " La contraseña debe tener al menos una letra mayúscula, una letra minúscula, un número y un caracter especial.",
        });
      } else {
        this.changePassword();
      }
    },

    // Cambio de contraseña
    async changePassword() {
      this.progreso = true;
      this.tokenuser = "";
      var passwordorigin = this.EmailOlvido + "#" + this.passwordNew;
      // Convertir constaseña en Password
      await this.sha256(this.passwordNew);
      passwordorigin = this.aesEncrypt(passwordorigin);
      // Token cifrado
      const fecha = format(new Date(), "yyyyMMddHHmmss");
      var token =
        this.EmailOlvido + "#" + this.EmailOlvido + "#" + fecha + "#" + this.PasswordSHA;
      this.tokenuser = this.aesEncrypt(token);
      var datainfo = {
        PasswordAES: passwordorigin,
        PasswordSHA: this.PasswordSHA,
        Token: this.tokenuser,
      };
      this.axios
        .post(this.$store.state.apiService + "/Autenticacion/changePassword/", datainfo)
        .then((response) => {
          this.dialog = false;
          this.dialogchange = false;
          this.otpdialog = false;
          this.emailOlvido = "";
          this.verifationcode = "";
          this.PasswordSHA = "";
          this.passwordNew = "";
          this.passwordNew2 = "";
          this.$swal({
            icon: "success",
            title: "Actualización exitosa.",
            html:
              " Su contraseña ha sido actualizada de manera exitosa, recuerde que esta es intransferible y es única para su acceso al sistema. Por favor inicie sesión nuevamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror = registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
  },
  mounted() {
    this.axios.defaults.baseURL = null;
    this.axios.defaults.headers.common["Authorization"] = null;
    this.axios.defaults.timeout = null;
  },
};
</script>
<style scoped>
.v-application .rounded-bl-xl {
  border-bottom-left-radius: 300px !important;
}
.v-application .rounded-br-xl {
  border-bottom-right-radius: 300px !important;
}
</style>
